<script lang="ts">
	import { onMount, onDestroy, afterUpdate } from "svelte";
	import { fade } from "svelte/transition";

	type Loaders = keyof typeof EC.loader;

	export let loaderType: Loaders = "full";
	export let fadeDuration: number = 150;
	export let outDelay: number | undefined = undefined;
	export let parent: HTMLElement | null = null;
	export let blur: boolean = false;

	let show: boolean = false;
	let loaderHTML = EC?.loader?.[loaderType] ?? "Loading...";

	onMount(() => setTimeout(() => (show = true), 0));
	afterUpdate(() => LoaderEc?.toggleParentPosition(parent, true));
	onDestroy(() => LoaderEc?.toggleParentPosition(parent, false));
</script>

{#if show}
	{#if blur}
		<div class="blur" />
	{:else}
		<div role="status" in:fade={{ duration: fadeDuration, delay: 0 }} out:fade={{ duration: fadeDuration, delay: outDelay }}>
			{@html loaderHTML}
		</div>
	{/if}
{/if}
